import store from '../store/'

export const orderDeliveriesApi = {

    getAllByOrderId (order_id) {
        return axios.get(`/api/company/${store.getters['user/activeCompanyId']}/promotional/${order_id}/delivery`)
    },

}
